import { FETCH_CONSIGNMENTS_SEARCH_RESULTS } from "../../../../../graphql/query/Consignment";
import { consignmentFilterStore } from "../../../components/useConsignmentFilters";

const SearchedConsignments = props => {
  const tableProps = {
    dataKey: "consignmentsV2",
    FETCH_QUERY: FETCH_CONSIGNMENTS_SEARCH_RESULTS,
    limit: 50,
    variables: {
      ...consignmentFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedConsignments;
